// Single source of truth for the plans/programs the lab accepts; feeds the
// Referring Practices section, the FAQ answer, and site search.
// public/llms.txt repeats this list by hand: update it too.
export const governmentPrograms = [
  { name: 'Medicare' },
  { name: 'Medicaid' },
  { name: 'TRICARE' },
  { name: 'CHAMPUS' }
];

export const healthPlans = [
  { name: 'Aetna' },
  { name: 'Ambetter' },
  { name: 'AvMed' },
  { name: 'Blue Cross' },
  { name: 'Cigna' },
  { name: 'Health Options' },
  { name: 'Humana' },
  { name: 'Meritain Health' },
  { name: 'Molina' },
  { name: 'Neighborhood Health' },
  { name: 'Simply Health Care' },
  { name: 'Sunshine State' },
  { name: 'UnitedHealthcare' }
];

const names = (list) => list.map((plan) => plan.name);

export const insuranceSummary = `${names(governmentPrograms).join(', ')}, ${names(healthPlans).join(', ')}`;
